import { Injectable } from '@angular/core';

@Injectable()
export class AbTestServerService {
    /* Fake one for SSR */
    public loadTarget(): Promise<string> {
        return Promise.resolve('');
    }
}
